/* eslint-disable no-unused-vars */
import apiService from '@/utils/api-client'
import analytics from "@/store/modules/analytics"
import store from '@/store'

export default {
  async createAutoTraceCase({ commit }, {
    title,
    directions = 1,
    direction = 1,
    firstFilter,
    tx_hash,
    token = '',
    address = [],
    channel,
    ...extraParams
  }) {
    try {
      const normalizedChannel = Array.isArray(channel)
        ? [...new Set(
            channel
              .filter(v => v != null)
              .map(v => String(v).toLowerCase())
          )]
        : channel

      const payload = {
        ...extraParams,
        title,
        directions,
        direction,
        tx_hash,
        token,
        channel: normalizedChannel
      }

      if (address.length) payload.address_or_cluster = address[0]
      if (!(Array.isArray(firstFilter?.address) && !firstFilter?.address?.length)) {
        payload.firstFilter = firstFilter
      }

      return apiService.post('report/unhosted', payload)
    } catch (error) {
      console.error(error)
    } finally {
      await store.dispatch('user/getMe')
    }
  },

  async editAutoTraceCase({ commit }, {
      enqId,
      title = undefined,
      sendMatch,
      // notificationChannels = undefined,
      coin,
      org_shared,
      // token,
    }) {
    try {
      const url = analytics?.state?.currencyList.find(el => el.key === coin).baseUrl

      const params = {
        title,
        sendMatch,
        org_shared,
      }

      // if (token) {
      //   params.token = token
      // }

      return apiService.patch(`report/unhosted/${enqId}`, params,
        {
          baseURL: url,
        }
      )
    } catch (error) {
      console.error(error)
    }
  },

  async deleteAutoTraceCase({ commit }, { id, coin }) {
    try {
      const url = analytics?.state?.currencyList.find(el => el.key === coin).baseUrl

      return apiService.delete(`report/unhosted/${id}`, {
        baseURL: url,
      })
    } catch (error) {
      console.error(error)
    }
  },

  async getAutoTraceList({ commit }, { coin, token, title }) {
    try {
      const coins = (analytics?.state?.currencyList || [])
        .filter(el => !coin || el.key === coin)
        .map(el => ({ baseUrl: el.baseUrl, coin: el.key }))
        .filter(el => el.baseUrl)

      const requests = coins.map(({ baseUrl, coin }) =>
        apiService.get('report/unhosted', {
          baseURL: baseUrl,
          params: { title, token }
        })
        .then(res => ({
          // res – это уже data из бэка
          count: res?.count || 0,
          items: (res?.items || []).map(item => ({ ...item, coin }))
        }))
        .catch(err => {
          console.error('getAutoTraceList error for', coin, err)
          return { count: 0, items: [] }
        })
      )

      const results = await Promise.all(requests)

      const combined = results.reduce((acc, res) => {
        acc.count += res.count || 0
        acc.items.push(...(res.items || []))
        return acc
      }, { count: 0, items: [] })

      return combined
    } catch (error) {
      console.error('getAutoTraceList fatal', error)
      return { count: 0, items: [] }
    }
  },

  async getAutoTraceCaseById({ commit }, { id, coin }) {
    try {
      const url = analytics?.state?.currencyList.find(el => el.key === coin).baseUrl

      const res = await apiService.get(`report/unhosted/${id}`, {
        baseURL: url,
      })

      return { ...res, coin }
    } catch ({ response }) {
      return { ...response, coin }
    }
  },

  async getAutoTraceCaseExposureSources({ commit }, {
    enqId,
    directionUp = true,
    token,
    coin,
    owner,
    funds,
    $sort,
    $skip,
    $limit,
    type,
  }) {
    try {
      const url = analytics?.state?.currencyList.find(el => el.key === coin)?.baseUrl

      const params = {
        directionUp,
        tokenTicker: coin?.toUpperCase?.() || '',
        $skip,
        $limit,
      }

      if (owner) {
        params.owner = owner
      } else if (funds?.name) {
        params['funds.name'] = funds.name
      }

      if (token) {
        params.token = token
      }

      if ($sort) {
        params.$sort = $sort
      }

      const data = await apiService.get(`report/unhosted/${enqId}/${type}`, {
        params,
        baseURL: url,
      })

      return data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getAutoTraceCaseExposureCsv({ commit }, {
    enqId,
    directionUp = true,
    token,
    coin,
    owner,
    funds,
    type,
  }) {
    try {
      const url = analytics?.state?.currencyList.find(el => el.key === coin)?.baseUrl

      const params = {
        directionUp,
        // tokenTicker: coin?.toUpperCase?.() || '',
      }

      if (owner) {
        params.owner = owner
      } else if (funds?.name) {
        params['funds.name'] = funds.name
      }

      if (token) {
        params.token = token
      }

      const data = await apiService.get(`report/unhosted/${enqId}/${type}`, {
        params,
        baseURL: url,
        headers: {
          'Accept': 'text/csv',
        },
      })

      return data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async atcRecognitionUnderhood(_, { tx, coin }) {
    let base = analytics?.state?.currencyList.find(el => el.key === coin)?.baseUrl

    if (!base.endsWith('/')) {
      base = base + '/'
    }

    const url = `${base}explorer/recognize?tx_hash=${tx}`

    try {
      const res = await apiService.get(url)
      return { data: res, error: null }
    } catch (err) {
      const errorData =
        err.response?.data ??
        { message: err.message || 'Unknown error' }

      return { data: null, error: errorData }
    }
  }
}